import { ref } from "vue";

// Composable para ordenação de tabelas de relatório via clique no cabeçalho da coluna.
export function useOrdenacao(campoPadrao: string | null = null, ascPadrao = true) {
  const campo = ref<string | null>(campoPadrao);
  const asc = ref(ascPadrao);

  function alternar(coluna: string) {
    if (campo.value === coluna) {
      asc.value = !asc.value;
    } else {
      campo.value = coluna;
      asc.value = true;
    }
  }

  function aplicar<T>(lista: T[], accessors?: Record<string, (item: T) => any>): T[] {
    if (!campo.value) return lista;

    const dir = asc.value ? 1 : -1;
    const coluna = campo.value;
    const get = (accessors && accessors[coluna]) || ((item: any) => item[coluna]);

    return [...lista].sort((a, b) => {
      const va = get(a);
      const vb = get(b);

      if (va == null && vb == null) return 0;
      if (va == null) return -1 * dir;
      if (vb == null) return 1 * dir;

      if (typeof va === "number" && typeof vb === "number") return (va - vb) * dir;
      if (typeof va === "boolean" && typeof vb === "boolean") return ((va === vb) ? 0 : (va ? 1 : -1)) * dir;

      return String(va).localeCompare(String(vb), "pt-BR", { sensitivity: "base", numeric: true }) * dir;
    });
  }

  function icone(coluna: string): string {
    if (campo.value !== coluna) return "fa-sort";
    return asc.value ? "fa-sort-up" : "fa-sort-down";
  }

  function classeIcone(coluna: string): string {
    return campo.value === coluna ? "fa " + icone(coluna) : "fa fa-sort text-muted opacity-50";
  }

  return { campo, asc, alternar, aplicar, icone, classeIcone };
}
